import HeaderBar from "./HeaderBar";
import React from "react";

interface Props {
  authenticated: boolean;
  appRole: any;
}

const Header = ({ authenticated, appRole }: Props) => {
  return <HeaderBar appRole={appRole} authenticated={authenticated} />;
};

export default React.memo(Header);
